import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { USERS } from "../../Components/users";
import logo from "../../Image/logo.png";
import tvImage from "../../Image/tv.img.png";
import { FiUser, FiLock, FiAlertCircle, FiArrowRight } from "react-icons/fi";
import SplashScreen from "./SplashScreen";

const CSS = `
  @keyframes fade-up {
    from { opacity: 0; transform: translateY(20px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes fade-in {
    from { opacity: 0; }
    to   { opacity: 1; }
  }
  @keyframes float {
    0%, 100% { transform: translateY(0px) rotate(-0.5deg); }
    50%       { transform: translateY(-10px) rotate(0.5deg); }
  }
  @keyframes pulse-ring {
    0%   { box-shadow: 0 0 0 0   rgba(99,102,241,0.4), 0 32px 80px rgba(0,0,0,0.7); }
    70%  { box-shadow: 0 0 0 10px rgba(99,102,241,0),  0 32px 80px rgba(0,0,0,0.7); }
    100% { box-shadow: 0 0 0 0   rgba(99,102,241,0),  0 32px 80px rgba(0,0,0,0.7); }
  }
  @keyframes live-blink {
    0%, 100% { opacity: 1; }
    50%       { opacity: 0.3; }
  }
  @keyframes scan-line {
    0%   { transform: translateY(-100%); opacity: 0.03; }
    100% { transform: translateY(400%);  opacity: 0.03; }
  }

  .fade-up    { animation: fade-up  0.65s cubic-bezier(.22,1,.36,1) both; }
  .fade-in    { animation: fade-in  0.5s ease both; }
  .float-card { animation: float    7s ease-in-out infinite; }
  .pulse-ring { animation: pulse-ring 2.5s ease-out infinite; }
  .live-dot   { animation: live-blink 1.4s ease-in-out infinite; }

  .login-input {
    width: 100%;
    padding: 0.85rem 1rem 0.85rem 2.8rem;
    border-radius: 0.875rem;
    border: 1px solid rgba(255,255,255,0.07);
    background: rgba(255,255,255,0.03);
    color: #e2e8f0;
    font-size: 0.875rem;
    transition: border-color 0.2s, background 0.2s, box-shadow 0.2s;
    outline: none;
    font-family: inherit;
    letter-spacing: 0.01em;
  }
  .login-input::placeholder { color: #2d3748; }
  .login-input:focus {
    border-color: rgba(99,102,241,0.55);
    background: rgba(99,102,241,0.04);
    box-shadow: 0 0 0 3px rgba(99,102,241,0.1);
  }

  .tile-hero {
    background: linear-gradient(135deg, #1a1060 0%, #2d1b69 50%, #0f172a 100%);
    position: relative;
    overflow: hidden;
  }
  .tile-hero::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, rgba(139,92,246,0.3) 0%, transparent 60%);
  }
`;

const ROWS = [
  {
    label: "Featured",
    tag: "Hero",
    tagColor: "#8b5cf6",
    hero: true,
    tiles: [
      { bg: "linear-gradient(135deg,#1a1060,#2d1b69,#0f172a)", accent: "#8b5cf6" },
      { bg: "linear-gradient(135deg,#0f2a1a,#1a4a2a,#0a1a0f)", accent: "#10b981" },
      { bg: "linear-gradient(135deg,#2a0f1a,#4a1a2a,#1a0a0f)", accent: "#f43f5e" },
      { bg: "linear-gradient(135deg,#0f1a2a,#1a2d4a,#0a0f1a)", accent: "#3b82f6" },
    ],
  },
  {
    label: "Trending Now",
    tag: "Active",
    tagColor: "#10b981",
    tiles: [
      { bg: "linear-gradient(135deg,#1a0f2a,#2d1a4a,#0f0a1a)", accent: "#a78bfa" },
      { bg: "linear-gradient(135deg,#0f2a1a,#1a3a2d,#0a1a10)", accent: "#34d399" },
      { bg: "linear-gradient(135deg,#2a1a0f,#4a2d1a,#1a0f0a)", accent: "#fb923c" },
      { bg: "linear-gradient(135deg,#0f1a2a,#1a2a3a,#0a0f1a)", accent: "#60a5fa" },
      { bg: "linear-gradient(135deg,#2a0f1a,#3a1a2d,#1a0a10)", accent: "#f472b6" },
    ],
  },
  {
    label: "New Episodes",
    tag: "Scheduled · Mon",
    tagColor: "#f59e0b",
    tiles: [
      { bg: "linear-gradient(135deg,#1a2a0f,#2d3a1a,#0f1a0a)", accent: "#a3e635" },
      { bg: "linear-gradient(135deg,#2a1a0f,#3a2d1a,#1a0f0a)", accent: "#fbbf24" },
      { bg: "linear-gradient(135deg,#0f1a2a,#1a2d3a,#0a0f1a)", accent: "#38bdf8" },
      { bg: "linear-gradient(135deg,#1a0f2a,#2d1a3a,#0f0a1a)", accent: "#c084fc" },
    ],
  },
];

const NAV_ITEMS = [
  { label: "Pages",    active: true },
  { label: "Rows",     active: false },
  { label: "Tiles",    active: false },
  { label: "Schedule", active: false },
  { label: "Sources",  active: false },
];

const LoginPage = () => {
  const navigate = useNavigate();
  const [username, setUsername]   = useState("");
  const [password, setPassword]   = useState("");
  const [error, setError]         = useState("");
  const [loading, setLoading]     = useState(false);
  const [showSplash, setShowSplash] = useState(false);
  const [mounted, setMounted]     = useState(false);

  useEffect(() => {
    const token = Cookies.get("authToken");
    if (token) navigate("/");
    requestAnimationFrame(() => setMounted(true));
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    await new Promise((r) => setTimeout(r, 380));
    const user = USERS.find((u) => u.u === username && u.p === password);
    if (!user) {
      setError("Invalid username or password");
      setLoading(false);
      return;
    }
    Cookies.set("authToken", "loggedIn", { expires: 1 });
    localStorage.setItem("cw_user", user.u);
    setShowSplash(true);
  };

  return (
    <>
      <style>{CSS}</style>
      {showSplash && <SplashScreen onDone={() => navigate("/")} />}

      <div
        className="h-screen w-full flex overflow-hidden"
        style={{ background: "#06080f", fontFamily: "'Plus Jakarta Sans', Inter, sans-serif" }}
      >

        {/* ════════════ LEFT PANEL ════════════ */}
        <div className="hidden lg:flex lg:w-[60%] relative overflow-hidden flex-col">

          {/* TV background image */}
          <img src={tvImage} alt="" className="absolute inset-0 w-full h-full object-cover pointer-events-none"
            style={{ opacity: 0.18, filter: "saturate(1.4) brightness(0.8)" }} />

          {/* Gradient overlays */}
          <div className="absolute inset-0 pointer-events-none" style={{
            background: "linear-gradient(135deg, #06080f 0%, rgba(6,8,15,0.75) 40%, rgba(6,8,15,0.55) 100%)"
          }} />
          <div className="absolute inset-0 pointer-events-none" style={{
            background: "linear-gradient(to right, transparent 50%, #06080f 100%)"
          }} />

          {/* Ambient color glows */}
          <div className="absolute pointer-events-none" style={{
            top: -120, left: -120, width: 600, height: 600,
            background: "radial-gradient(circle, rgba(99,102,241,0.15) 0%, transparent 60%)",
          }} />
          <div className="absolute pointer-events-none" style={{
            bottom: -80, right: 80, width: 500, height: 500,
            background: "radial-gradient(circle, rgba(139,92,246,0.1) 0%, transparent 60%)",
          }} />
          <div className="absolute pointer-events-none" style={{
            top: "40%", left: "30%", width: 400, height: 400,
            background: "radial-gradient(circle, rgba(59,130,246,0.07) 0%, transparent 60%)",
          }} />

          {/* Content */}
          <div className="relative z-10 flex flex-col h-full p-10 justify-between">

            {/* Logo */}
            <div className={mounted ? "fade-in" : "opacity-0"} style={{ animationDelay: "0.05s" }}>
              <img src={logo} alt="Cloudwalker" className="h-8 object-contain"
                style={{ filter: "drop-shadow(0 0 14px rgba(99,102,241,0.6))", objectPosition: "left" }} />
            </div>

            {/* Dashboard mockup */}
            <div className="flex items-center justify-center">
              <div
                className={`w-full max-w-[500px] rounded-2xl overflow-hidden float-card pulse-ring ${mounted ? "fade-up" : "opacity-0"}`}
                style={{
                  animationDelay: "0.2s",
                  background: "rgba(10,13,25,0.95)",
                  border: "1px solid rgba(99,102,241,0.2)",
                  backdropFilter: "blur(20px)",
                }}
              >
                {/* Window chrome */}
                <div className="flex items-center gap-2 px-4 py-3" style={{
                  borderBottom: "1px solid rgba(255,255,255,0.05)",
                  background: "rgba(6,8,15,0.8)",
                }}>
                  <div className="flex gap-1.5">
                    <div className="w-3 h-3 rounded-full" style={{ background: "#ff5f57" }} />
                    <div className="w-3 h-3 rounded-full" style={{ background: "#febc2e" }} />
                    <div className="w-3 h-3 rounded-full" style={{ background: "#28c840" }} />
                  </div>
                  <div className="flex-1 flex justify-center">
                    <div className="px-4 py-1 rounded-md text-[10px] font-medium flex items-center gap-2"
                      style={{ background: "rgba(255,255,255,0.04)", color: "#374151", border: "1px solid rgba(255,255,255,0.06)" }}>
                      <div className="w-1.5 h-1.5 rounded-full live-dot" style={{ background: "#10b981" }} />
                      catalog-builder · Home Page
                    </div>
                  </div>
                  <div className="w-14" />
                </div>

                {/* App shell */}
                <div className="flex" style={{ minHeight: 300 }}>

                  {/* Sidebar */}
                  <div className="shrink-0 flex flex-col py-3 px-2 gap-0.5"
                    style={{ width: 100, borderRight: "1px solid rgba(255,255,255,0.05)", background: "rgba(6,8,15,0.6)" }}>
                    {NAV_ITEMS.map(({ label, active }) => (
                      <div key={label}
                        className="flex items-center gap-2 px-2.5 py-1.5 rounded-lg text-[10px] font-semibold cursor-default"
                        style={{
                          background: active ? "rgba(99,102,241,0.15)" : "transparent",
                          color: active ? "#a5b4fc" : "#2d3748",
                          border: active ? "1px solid rgba(99,102,241,0.2)" : "1px solid transparent",
                          transition: "all 0.15s",
                        }}>
                        <div className="w-1.5 h-1.5 rounded-full flex-shrink-0"
                          style={{ background: active ? "#6366f1" : "#1f2937" }} />
                        {label}
                      </div>
                    ))}
                  </div>

                  {/* Main area */}
                  <div className="flex-1 p-4 overflow-hidden">

                    {/* Top bar */}
                    <div className="flex items-center justify-between mb-5">
                      <div>
                        <div className="text-[12px] font-bold text-white tracking-tight">Home Page</div>
                        <div className="text-[9px] mt-0.5" style={{ color: "#374151" }}>3 rows · 16 tiles · Last edited 2h ago</div>
                      </div>
                      <div className="flex items-center gap-2">
                        <div className="px-2.5 py-1 rounded-lg text-[9px] font-bold"
                          style={{ background: "rgba(16,185,129,0.1)", color: "#34d399", border: "1px solid rgba(16,185,129,0.2)" }}>
                          ● Published
                        </div>
                        <div className="w-6 h-6 rounded-lg flex items-center justify-center cursor-default"
                          style={{ background: "rgba(99,102,241,0.15)", color: "#818cf8", fontSize: 14, border: "1px solid rgba(99,102,241,0.2)" }}>
                          +
                        </div>
                      </div>
                    </div>

                    {/* Rows */}
                    <div className="space-y-5">
                      {ROWS.map((row) => (
                        <div key={row.label}>
                          <div className="flex items-center gap-2 mb-2">
                            <span className="text-[10px] font-bold" style={{ color: "#94a3b8" }}>{row.label}</span>
                            <span className="text-[8px] font-bold px-1.5 py-0.5 rounded-full"
                              style={{ background: `${row.tagColor}18`, color: row.tagColor, border: `1px solid ${row.tagColor}28` }}>
                              {row.tag}
                            </span>
                          </div>
                          <div className="flex gap-1.5">
                            {row.tiles.map((tile, ti) => (
                              <div
                                key={ti}
                                style={{
                                  flex: row.hero && ti === 0 ? "0 0 72px" : "0 0 48px",
                                  height: row.hero ? 44 : 32,
                                  borderRadius: 7,
                                  background: tile.bg,
                                  border: `1px solid ${tile.accent}22`,
                                  position: "relative",
                                  overflow: "hidden",
                                  flexShrink: 0,
                                }}
                              >
                                {/* shimmer line */}
                                <div style={{
                                  position: "absolute",
                                  inset: 0,
                                  background: `linear-gradient(135deg, ${tile.accent}18 0%, transparent 70%)`,
                                }} />
                              </div>
                            ))}
                            <div style={{
                              flex: "0 0 32px",
                              height: row.hero ? 44 : 32,
                              borderRadius: 7,
                              border: "1px dashed rgba(255,255,255,0.08)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color: "#1f2937",
                              fontSize: 16,
                              flexShrink: 0,
                            }}>+</div>
                          </div>
                        </div>
                      ))}
                    </div>

                  </div>
                </div>

                {/* Footer */}
                <div className="flex items-center justify-between px-5 py-2.5"
                  style={{ borderTop: "1px solid rgba(255,255,255,0.05)", background: "rgba(6,8,15,0.6)" }}>
                  <div className="flex items-center gap-3">
                    <span className="text-[9px]" style={{ color: "#1f2937" }}>CloudTV OS</span>
                    <span style={{ color: "#1f2937", fontSize: 9 }}>·</span>
                    <span className="text-[9px]" style={{ color: "#1f2937" }}>v2.4.1</span>
                  </div>
                  <div className="flex items-center gap-1.5">
                    <div className="w-1.5 h-1.5 rounded-full live-dot" style={{ background: "#10b981" }} />
                    <span className="text-[9px] font-medium" style={{ color: "#374151" }}>All systems live</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Bottom headline */}
            <div className={mounted ? "fade-up" : "opacity-0"} style={{ animationDelay: "0.3s" }}>
              <h1 className="text-[2.2rem] font-extrabold text-white mb-2.5" style={{ letterSpacing: "-0.04em", lineHeight: 1.1 }}>
                Catalog Builder
              </h1>
              <p className="text-sm leading-relaxed" style={{ color: "#2d3748", maxWidth: 340 }}>
                Design and schedule content catalogs for CloudTV OS — pages, rows, tiles and deep links.
              </p>
            </div>

          </div>
        </div>

        {/* ════════════ RIGHT PANEL ════════════ */}
        <div className="flex-1 relative flex flex-col items-center justify-center px-8 overflow-hidden"
          style={{ background: "linear-gradient(160deg, #0a0d18 0%, #06080f 100%)" }}>

          {/* Glows */}
          <div className="absolute inset-0 pointer-events-none" style={{
            background: "radial-gradient(ellipse 80% 50% at 50% 0%, rgba(99,102,241,0.08), transparent)"
          }} />
          <div className="absolute pointer-events-none" style={{
            bottom: -100, left: "50%", transform: "translateX(-50%)",
            width: 400, height: 400,
            background: "radial-gradient(circle, rgba(99,102,241,0.06) 0%, transparent 65%)",
          }} />

          {/* Subtle dot grid */}
          <div className="absolute inset-0 pointer-events-none" style={{
            backgroundImage: "radial-gradient(rgba(99,102,241,0.12) 1px, transparent 1px)",
            backgroundSize: "28px 28px",
            opacity: 0.4,
            maskImage: "radial-gradient(ellipse 80% 80% at 50% 50%, black, transparent)",
            WebkitMaskImage: "radial-gradient(ellipse 80% 80% at 50% 50%, black, transparent)",
          }} />

          <div
            className={`relative z-10 w-full max-w-[340px] ${mounted ? "fade-up" : "opacity-0"}`}
            style={{ animationDelay: "0.1s" }}
          >

            {/* Mobile logo */}
            <div className="lg:hidden text-center mb-10">
              <img src={logo} alt="Cloudwalker" className="h-9 mx-auto object-contain"
                style={{ filter: "drop-shadow(0 0 12px rgba(99,102,241,0.5))" }} />
            </div>

            {/* Form card */}
            <div className="rounded-2xl p-8" style={{
              background: "rgba(255,255,255,0.025)",
              border: "1px solid rgba(255,255,255,0.07)",
              boxShadow: "0 24px 60px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.06)",
              backdropFilter: "blur(20px)",
            }}>

              {/* Heading */}
              <div className="mb-7">
                <div className="flex items-center gap-2 mb-3">
                  <img src={logo} alt="" className="h-6 object-contain lg:block hidden"
                    style={{ filter: "drop-shadow(0 0 8px rgba(99,102,241,0.5))" }} />
                </div>
                <h2 className="text-[1.6rem] font-extrabold text-white" style={{ letterSpacing: "-0.035em" }}>
                  Welcome back
                </h2>
                <p className="text-sm mt-1" style={{ color: "#2d3748" }}>
                  Sign in to manage your catalog
                </p>
              </div>

              <form onSubmit={handleLogin} className="space-y-4">

                {/* Username */}
                <div>
                  <label className="block text-[10px] font-semibold tracking-widest uppercase mb-2" style={{ color: "#2d3748" }}>
                    Username
                  </label>
                  <div className="relative">
                    <FiUser size={14} className="absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none"
                      style={{ color: "#374151" }} />
                    <input className="login-input" value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      placeholder="your_username" autoComplete="username" />
                  </div>
                </div>

                {/* Password */}
                <div>
                  <label className="block text-[10px] font-semibold tracking-widest uppercase mb-2" style={{ color: "#2d3748" }}>
                    Password
                  </label>
                  <div className="relative">
                    <FiLock size={14} className="absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none"
                      style={{ color: "#374151" }} />
                    <input type="password" className="login-input" value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="••••••••" autoComplete="current-password" />
                  </div>
                </div>

                {/* Error */}
                {error && (
                  <div className="fade-in flex items-center gap-2 px-3.5 py-2.5 rounded-xl text-sm"
                    style={{ background: "rgba(239,68,68,0.07)", border: "1px solid rgba(239,68,68,0.15)", color: "#f87171" }}>
                    <FiAlertCircle size={13} className="shrink-0" />
                    <span>{error}</span>
                  </div>
                )}

                {/* Submit */}
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full flex items-center justify-center gap-2 py-3 rounded-xl font-semibold text-sm text-white disabled:opacity-40 disabled:cursor-not-allowed"
                  style={{
                    marginTop: "1.25rem",
                    background: "linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)",
                    boxShadow: loading ? "none" : "0 4px 20px rgba(99,102,241,0.4), inset 0 1px 0 rgba(255,255,255,0.15)",
                    transition: "opacity 0.2s, transform 0.15s, box-shadow 0.2s",
                  }}
                  onMouseEnter={e => { if (!loading) e.currentTarget.style.transform = "translateY(-1px)"; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; }}
                >
                  {loading ? (
                    <>
                      <span className="w-3.5 h-3.5 border-2 rounded-full animate-spin"
                        style={{ borderColor: "rgba(255,255,255,0.2)", borderTopColor: "#fff" }} />
                      <span>Signing in…</span>
                    </>
                  ) : (
                    <>
                      <span>Sign In</span>
                      <FiArrowRight size={15} />
                    </>
                  )}
                </button>
              </form>
            </div>

            <p className="text-center mt-5 text-[11px]" style={{ color: "#1a2030" }}>
              © {new Date().getFullYear()} Cloudwalker Technologies
            </p>
          </div>
        </div>

      </div>
    </>
  );
};

export default LoginPage;
